<template>
  <div>
    <label id="fileBtn" for="hiddenBtn" class="file">
      <i class="las la-paperclip"></i>
      Select File
    </label>

    <input
      id="hiddenBtn"
      ref="input"
      type="file"
      accept=".pdf"
      :name="name"
      @change="onCvFileChange"
    />

    <div class="file-name">
      {{ filename || cachedFilename }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputFile',

  props: {
    cachedFileData: {
      type: String,
      default: () => '',
    },
    name: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      filename: '',
    }
  },

  computed: {
    cachedFilename: function () {
      if (this.cachedFileData) {
        return JSON.parse(this.cachedFileData).metadata.filename
      } else {
        return ''
      }
    },
  },

  watch: {
    // A newly cached file (e.g. from CV autofill) replaces any file picked here;
    // otherwise this input would override it on submit since both share the same name.
    cachedFileData() {
      this.filename = ''
      this.$refs.input.value = ''
    },
  },

  methods: {
    onCvFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      this.filename = files[0].name
      this.$emit('file-selected', e)
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'stylesheets/global';

.file {
  background: transparent;
  border: 1px solid $blue-primary;
  border-radius: 100rem;
  box-shadow: none;
  color: $blue-primary;
  cursor: pointer;
  display: inline-flex;
  filter: contrast(150%);
  font-size: 1em;
  font-weight: 500;
  padding: 1rem 2rem;
  text-align: center;
  text-decoration: none;
  transition: all 0.4s ease-in-out;
  width: fit-content;
}

i {
  font-size: 20px;
  margin-right: 5px;
}

input[type='file'] {
  display: none;
}
</style>
